import { useAsyncAPI } from "~/uses/useMyFetch";

export const getProductsByLabel = async (
  label,
  sort = "random",
  limit = 20,
  fields,
) => {
  return useAsyncAPI("/catalog/product/list/label", {
    params: {
      label,
      "fields[]": fields,
      limit,
      sort,
    },
    lazy: true,
  });
};

export const getReviewAttachments = (review, format = undefined) => {
  const attachments = [];

  if (null !== review.youtubeVideoId) {
    attachments.push({
      youtubeVideoId: review.youtubeVideoId,
      reviewId: review.documentId,
    });
  }

  review.attachments?.forEach((attachment) =>
    attachments.push({
      url: normalizeStrapiUrl(
        attachment.formats[format]?.url ?? attachment.url,
      ),
      reviewId: review.documentId,
    }),
  );

  return attachments;
};

export const getYoutubeVideoPreview = (videoId) => {
  return `https://i.ytimg.com/vi_webp/${videoId}/sddefault.webp`;
};
